import { createContext, useContext } from "react";
export const ViewStateContext = createContext(undefined);
export const useViewStateContext = () => useContext(ViewStateContext);
